import React from "react";
import { PROGRAM_SPECIFIC_NAMES } from "../Helpers/constants";

export type DxpRegistrationTopHeaderProps = {
  /** Key into `PROGRAM_SPECIFIC_NAMES`; default `DXP` */
  program?: string;
  logoSrc?: string;
  title?: string;
  logoAlt?: string;
  /** Optional `id` on the logo image (e.g. legacy selectors) */
  logoId?: string;
  className?: string;
};

/**
 * Shared top bar for DXP registration wizard pages: Adobe logo + partner program title.
 */
function DxpRegistrationTopHeader({
  program = "DXP",
  logoSrc,
  title,
  logoAlt = "Adobe",
  logoId,
  className,
}: DxpRegistrationTopHeaderProps) {
  const cfg = PROGRAM_SPECIFIC_NAMES[program] ?? PROGRAM_SPECIFIC_NAMES.DXP;
  const partner = cfg.partnerProgram;
  const resolvedLogo = logoSrc ?? partner.logoLink;
  const resolvedTitle = title ?? partner.title;

  return (
    <header
      className={["dxp-reg-top-bar", className].filter(Boolean).join(" ")}
    >
      <div className="dxp-reg-top-bar__inner">
        <img
          {...(logoId ? { id: logoId } : {})}
          src={resolvedLogo}
          alt={logoAlt}
          className="dxp-reg-top-bar__logo"
        />
        <span className="dxp-reg-top-bar__title">{resolvedTitle}</span>
      </div>
    </header>
  );
}

export default DxpRegistrationTopHeader;
